// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"e5a3e7e5","317":"cb9b424e","495":"20cf9fe4","650":"a2e8ba5c","771":"b7cbac01","787":"6efe667f","906":"c3801a85","936":"9ec280b2","956":"1ad93df3","968":"df5cf01f"}[chunkId] + ".chunk.js";
};